<section
	class="zk-flex zk-flex-col xl:zk-grid zk-grid-cols-2 zk-gap-x-8 zk-gap-y-4"
>
	<ng-container *ngIf="billingType == 'natural'">
		<div class="file zk-w-full" *ngFor="let document of naturalDocuments">
			<ng-container
				*ngTemplateOutlet="uploadItem; context: { document: document }"
			></ng-container>
		</div>
	</ng-container>

	<ng-container *ngIf="billingType == 'legal'">
		<div class="file zk-w-full">
			<ng-container
				*ngTemplateOutlet="uploadItem; context: { document: legalDocuments[0] }"
			></ng-container>
		</div>
	</ng-container>
</section>

<ng-template #uploadItem let-document="document">
	<zk-input-upload
		[accept]="'image/*,application/pdf'"
		[title]="document.title | translate"
		[description]="document.description | translate"
		[labelSelectFile]="
			(document.filesUploaded?.length
				? document.labelChangeFile
				: document.labelSelectFile
			) | translate
		"
		[labelChangeFile]="document.labelChangeFile | translate"
		[dialogTitle]="
			'MY_ACCOUNT.FINANCIAL.BILLING_DOCUMENTS.DIALOG_TITLE' | translate
		"
		[dialogShowIcon]="document.dialog.showIcon"
		[dialogLabelSelectFile]="document.dialog.labelSelectFile | translate"
		[dialogLabelCancel]="document.dialog.labelCancel | translate"
		[dialogLabelNext]="document.dialog.labelNext | translate"
		[uploading]="document.dialog.uploading"
		[filesUploated]="document.filesUploaded"
		[uploadStatus]="getDocumentStatus(document)"
		[isOpenDialog]="document.dialog.isOpen"
		(upload)="uploadFile($event, document)"
	>
		<ng-container zk-upload-dialog-body>
			<h1 class="zk-text-1 zk-text-lg zk-font-thick">
				{{ document.title | translate }}
			</h1>
			<p
				class="zk-text-2 zk-text-sm zk-mt-4"
				*ngIf="document.dialog.description"
			>
				{{ document.dialog.description | translate }}
			</p>
		</ng-container>
	</zk-input-upload>
	<p
		class="zk-text-left zk-text-error zk-mt-1 zk-text-xs"
		*ngIf="getDocumentStatus(document.uploadStatus) === 'error'"
	>
		{{ document.errorMessage | translate }}
	</p>
</ng-template>
